import React, { useState } from "react"
import "../Themes.css"

import { Header, Footer } from "../../components/Sections"
import { MapsContainer, AcceptBiovelox } from "../../components/RHFComponents/live_components"
import onSubmitFactory from "./onSubmit"
import {
	InputFactory,
	InputFileFactory,
	GoogleAutoCompleteFactory,
	SelectAutoCompleteFactory,
	PhoneControllerFactory,
} from "../../components/RHFComponents"
import { addRecordBiovelox, filterPrescribers } from "../../services/api"

import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"

import schema from "../../schemas/record_biovelox"
import { joiResolver } from "@hookform/resolvers/joi"
export default function Form({
	acceptComponent: AcceptComponent = AcceptBiovelox,
	successRoute = "/success-biovelox",
	submitRecord = addRecordBiovelox,
	cryotherapie = false,
}) {
	const navigate = useNavigate()
	const [isSubmitting, setIsSubmitting] = useState(false)

	const {
		control,
		register,
		handleSubmit,
		setError,
		watch,
		formState: { errors },
	} = useForm({
		resolver: joiResolver(schema) /* mode: "onBlur" */,
		// defaultValues: {
		// 	firstname: "John",
		// 	lastname: "Doe",
		// 	birth: "1990-01-01",
		// 	email: "karcenty.pro@gmail.com",
		// 	phone: "0634567890",
		// 	toggle_manual_shipping_address: true,
		// 	manual_shipping_address: "123 Main St",
		// 	manual_shipping_postal_code: "12345",
		// 	manual_shipping_city: "City",
		// 	social_security: "190017510943402",
		// 	amc: "987654321",
		// 	mutual_photo: null,
		// 	prescriber: null,
		// 	prescription: null,
		// 	needMeasurements: "false",
		// 	accept: true,
		// },
	}) // to validate each time we leave a field.
	const Input = InputFactory(register, errors)
	const InputFile = InputFileFactory(register, control, errors)
	const GoogleAutoComplete = GoogleAutoCompleteFactory(control)
	const SelectAutoComplete = SelectAutoCompleteFactory(control)
	const PhoneInput = PhoneControllerFactory(control)
	const onSubmit = onSubmitFactory(navigate, setIsSubmitting, setError, successRoute, submitRecord)
	const {
		toggle,
		toggle_manual_shipping_address,
		toggle_manual_billing_address,
		prescription,
		prescription_bis,
		toggle_prescription_bis,
		toggle_prescription_ter,
	} = watch()

	console.log(errors)
	return (
		<div>
			<Header />
			<div className="title-formula">Formulaire de commande</div>
			<div className="under-title-formula"></div>

			<form className="form-big" onSubmit={handleSubmit(onSubmit)}>
				{Input("text", "firstname", "Prénom")}
				{Input("text", "lastname", "Nom")}
				{Input("email", "email", "Email")}
				{PhoneInput("phone", "Téléphone portable")}
				{!toggle_manual_shipping_address && (
					<>
						{GoogleAutoComplete(
							"shipping_address",
							"Adresse de livraison",
							"Si votre adresse est introuvable, vous pouvez la remplir manuellement",
						)}
						{Input("text", "manual_shipping_additional_address_line", "Complément d'adresse")}
						<div>
							<label className="address-note">
								Votre adresse de livraison est introuvable ?
								<input type="checkbox" {...register("toggle_manual_shipping_address")} />
							</label>
						</div>
					</>
				)}
				{toggle_manual_shipping_address && (
					<div>
						<div className="address-note">Veuillez rentrer votre addresse de livraison manuellement</div>
						{Input("text", "manual_shipping_address", "Adresse Livraison")}
						{Input("text", "manual_shipping_additional_address_line", "Complément d'adresse ")}
						{Input("text", "manual_shipping_postal_code", "Code Postal")}
						{Input("text", "manual_shipping_city", "Ville ")}
					</div>
				)}
				<div
					className="address-note"
					style={{
						display: toggle ? "none" : "block", // toggle the visbility of an input
					}}
				>
					<div>Votre adresse de facturation est différente ?</div>
					{/* <input type="checkbox" name="toggle" {...register("toggle")} /> */}
					<label>
						Oui
						<input type="radio" value={"true"} {...register("toggle")} />
					</label>
					<label>
						Non
						<input type="radio" value={"false"} {...register("toggle")} />
					</label>
				</div>
				{toggle === "true" && (
					<>
						{!toggle_manual_billing_address && (
							<>
								{GoogleAutoComplete(
									"address",
									"Adresse de facturation",
									"Si votre adresse est introuvable, vous pouvez la remplir manuellement",
								)}
								{Input("text", "manual_billing_additional_address_line", "Complément d'adresse")}
								<div>
									<label className="prescription-note">
										Votre adresse de facturation est introuvable ?
										<input type="checkbox" {...register("toggle_manual_billing_address")} />
									</label>
								</div>
							</>
						)}
						{toggle_manual_billing_address && (
							<div>
								<div className="prescription-note">Veuillez rentrer votre adresse de facturation manuellement</div>
								{Input("text", "manual_billing_address", "Adresse Facturation")}
								{Input("text", "manual_billing_additional_address_line", "Complément d'adresse")}
								{Input("text", "manual_billing_postal_code", "Code Postal")}
								{Input("text", "manual_billing_city", "Ville")}
							</div>
						)}
					</>
				)}
				<div className="arange-map">
					<MapsContainer control={control} />
				</div>
				{/*Input(
                    "text",
                    "mutual",
                    "Mutuelle",
                    "Le nom de votre Mutuelle Santé est située sur votre carte de mutuelle et sur votre compte Ameli.fr dans la rubrique 'complémentaire santé'"
                )} */}
				{SelectAutoComplete(
					"prescriber",
					filterPrescribers,
					"Prescripteur",
					"Ici vous rentrez le nom du médecin ayant délivré votre ordonnance. Si il n'est pas dans les options, ne rentrez rien.",
				)}
				{cryotherapie && (
					<div className="cryotherapie-fields">
						{Input(
							"date",
							"surgery_date",
							"En cas d'intervention, précisez la date",
							"Cliquez sur la flèche pour ouvrir le calendrier",
						)}
						<div className="input-container cryotherapie-zone">
							<label htmlFor="intervention_zone">Articulation ou partie du corps opérée </label>
							<select
								id="intervention_zone"
								className={errors?.intervention_zone ? "input-field errorClass" : "input-field"}
								defaultValue=""
								{...register("intervention_zone")}
							>
								<option value="">Sélectionnez une zone</option>
								<option value="épaule">Épaule</option>
								<option value="hanche">Hanche</option>
								<option value="genou">Genou</option>
								<option value="cheville">Cheville</option>
								<option value="pied">Pied</option>
								<option value="jambe entière">Jambe entière</option>
							</select>
							{errors?.intervention_zone?.message}
						</div>
					</div>
				)}
				{/* {Input(
                    "text",
                    "size",
                    "Si possible, précisez la taille de l'attelle",
                    "Vous pouvez ici donner votre pointure (42) ou alors la taille de l'attelle (S,M,L)"
                )} */}
				{InputFile(
					"prescription",
					"Vous pouvez prendre en photo et/ou deposer votre ordonnance. Important : si vous ne parvenez pas à joindre le fichier, basculez sur le navigateur Google Chrome",
					"Ordonnance",
				)}
				{prescription && prescription.length > 0 && (
					<div
						className="text_toggle"
						style={{
							display: toggle_prescription_bis ? "none" : "block", // toggle the visbility of an input
						}}
					>
						Voulez-vous déposer une deuxième ordonnance ?
						<input type="checkbox" name="toggle_prescription_bis" {...register("toggle_prescription_bis")} />
					</div>
				)}
				{toggle_prescription_bis &&
					InputFile(
						"prescription_bis",
						"Vous pouvez prendre en photo et/ou deposer votre ordonnance. Important : si vous ne parvenez pas à joindre le fichier, basculez sur le navigateur Google Chrome",
						"Ordonnance",
					)}
				{prescription_bis && prescription_bis.length > 0 && (
					<div
						className="text_toggle"
						style={{
							display: toggle_prescription_ter ? "none" : "block", // toggle the visbility of an input
						}}
					>
						Voulez-vous déposer une troisième ordonnance ?
						<input type="checkbox" name="toggle_prescription_ter" {...register("toggle_prescription_ter")} />
					</div>
				)}
				{toggle_prescription_ter &&
					InputFile(
						"prescription_ter",
						"Vous pouvez prendre en photo et/ou deposer votre ordonnance. Important : si vous ne parvenez pas à joindre le fichier, basculez sur le navigateur Google Chrome",
						"Ordonnance",
					)}
				<div className="accept-bulletin-flex">
					{Input("checkbox", "accept", "", "", "", "", "", "error")}
					<AcceptComponent control={control} />
				</div>
				<input className="button-submit-patient" type="submit" value="Envoyer" disabled={isSubmitting} />
				<div className="final-error"> {Object.keys(errors).length > 0 && "Vérifiez les champs requis"}</div>
			</form>
			<Footer route="/urgences" text="Je suis déjà équipé" />
		</div>
	)
}
